import React from 'react';

import { AverageRating } from '../bar-rating';

import styles from './bar-rating-item.scss';

interface BarRatingItemProps {
  averageRating?: AverageRating;
}

function BarRatingItem(props: BarRatingItemProps) {
  const { averageRating } = props;

  return (
    <div className={styles['average-rating']}>
      <span className={styles['average-rating-title']}>
        {averageRating?.label}
      </span>
      <div className={styles['average-rating-bar']}>
        <span
          className={styles['average-rating-bar-fill']}
          style={{
            width: `${((averageRating?.value || 0) / 5) * 100}%`
          }}
        />
      </div>
      <span className={styles['average-rating-value']}>
        {averageRating?.value?.toFixed(1)}
      </span>
    </div>
  );
}

export default BarRatingItem;
